export function isMac() {
  return (/mac/i).test(navigator.platform);
}